import { PaymentType } from 'shared/enums/PaymentType';
import { t } from 'localization/utils/t';

const TP = 'checkout.enums.PaymentVendor';

export enum PaymentVendor {
  Affirm = 'affirm',
  AfterPay = 'afterpay',
  AliPay = 'alipay',
  ApplePay = 'applepay',
  CreditCard = 'creditcard',
  Giropay = 'giropay',
  Klarna = 'klarna',
  PayPal = 'paypal',
}

/**
 * not quite sure what the difference between PaymentVendor and Payment type is
 * I think this could be eventually refactored to use the same enums
 */
export const PaymentTypeToPaymentVendor = {
  [PaymentType.Affirm]: PaymentVendor.Affirm,
  [PaymentType.AfterPay]: PaymentVendor.AfterPay,
  [PaymentType.Alipay]: PaymentVendor.AliPay,
  [PaymentType.ApplePay]: PaymentVendor.ApplePay,
  [PaymentType.CreditCard]: PaymentVendor.CreditCard,
  [PaymentType.Giropay]: PaymentVendor.Giropay,
  [PaymentType.Klarna]: PaymentVendor.Klarna,
  [PaymentType.PayPal]: PaymentVendor.PayPal,
};

export const PaymentVendorNameMap = {
  [PaymentVendor.Affirm]: {
    value: t(`${TP}.Affirm`, 'Affirm'),
    TK: 'Affirm',
    TP,
  },
  [PaymentVendor.AfterPay]: {
    value: t(`${TP}.AfterPay`, 'Afterpay'),
    TK: 'AfterPay',
    TP,
  },
  [PaymentVendor.AliPay]: {
    value: t(`${TP}.AliPay`, 'Alipay'),
    TK: 'Alipay',
    TP,
  },
  [PaymentVendor.ApplePay]: {
    value: t(`${TP}.ApplePay`, 'Apple Pay'),
    TK: 'ApplePay',
    TP,
  },
  [PaymentVendor.CreditCard]: {
    value: t(`${TP}.CreditCard`, 'Credit Card'),
    TK: 'CreditCard',
    TP,
  },
  [PaymentVendor.Giropay]: {
    value: t(`${TP}.Giropay`, 'Giropay'),
    TK: 'Giropay',
    TP,
  },
  [PaymentVendor.Klarna]: {
    value: t(`${TP}.Klarna`, 'Klarna'),
    TK: 'Klarna',
    TP,
  },
  [PaymentVendor.PayPal]: {
    value: t(`${TP}.PayPal`, 'PayPal'),
    TK: 'Paypal',
    TP,
  },
};

export const PaymentVendorUrl = {
  afterpayStatic: 'https://static-us.afterpay.com/javascript/present-afterpay.js',
};

// In Cents
export const PaymentVendorPriceRange = {
  [PaymentVendor.Affirm]: {
    min: 5000,
  },
  [PaymentVendor.AfterPay]: {
    min: 3500,
    max: 100000,
  },
  [PaymentVendor.PayPal]: {
    min: 1,
  },
};

export const PaymentVendorAllowedCurrency = {
  [PaymentVendor.Affirm]: {
    Other: 'USD',
  },
  [PaymentVendor.AfterPay]: {
    Other: 'USD',
  },
  [PaymentVendor.AliPay]: {
    Other: 'USD',
  },
  [PaymentVendor.PayPal]: {
    CA: 'CAD',
    Other: 'USD',
  },
  [PaymentVendor.Giropay]: {
    Other: 'EUR',
  },
};
